<div class="container-fluid">
    <div class="d-flex justify-content-between align-items-center mb-3 mt-2">
        <h1 class="mb-0">Business List</h1>
        <div class="search-container">
            <mat-icon class="search-icon">search</mat-icon>
            <input type="text" placeholder="Search businesses..." [(ngModel)]="filterValue" (input)="applyFilter($event)" class="search-input" />
            @if (filterValue) {
                <mat-icon class="clear-icon cursor-pointer" (click)="clearFilter()" title="Clear search">close</mat-icon>
            }
        </div>
    </div>
    <div class="card overflow-auto" appDynamicHeight [offset]="165" [minHeight]="300">
        <table mat-table [dataSource]="dataSource" matSort [matSortActive]="sortActive" [matSortDirection]="sortDirection" (matSortChange)="onSortChange($event)" class="mat-elevation-z8">

            <!-- Serial Number Column -->
            <ng-container matColumnDef="serial_no">
                <th mat-header-cell *matHeaderCellDef> # </th>
                <td mat-cell *matCellDef="let element; let i = index"> {{i + 1}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Business Name</th>
                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="business_admin_email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Business Email</th>
                <td mat-cell *matCellDef="let element"> {{element.business_admin_email}} </td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Account Status </th>
                <td mat-cell *matCellDef="let element">
                    <span class="status-badge" [ngClass]="getStatusClass(element.status)">
                        {{element.status | uppercase }}
                    </span>
                </td>
            </ng-container>

            <!-- Created At Column -->
            <ng-container matColumnDef="created_at">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center"> Created On </th>
                <td mat-cell *matCellDef="let element" class="text-center"> {{element.created_at | dateFormat }} </td>
            </ng-container>

            <!-- Expiry Date Column -->
            <ng-container matColumnDef="expiry_date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center"> Expiry Date </th>
                <td mat-cell *matCellDef="let element" class="text-center">{{element.expiry_date | dateFormat }}</td>
            </ng-container>

            <ng-container matColumnDef="expiry_status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">
                    Expiry Status
                </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                    <span class="expiry-badge" [ngClass]="getExpiryStatus(element.expiry_date).class">

                        {{ getExpiryStatus(element.expiry_date).label }}
                    </span>
                </td>
            </ng-container>

            <!-- Screen Limit Column -->
            <ng-container matColumnDef="screen_limit">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center"> Screen Limit </th>
                <td mat-cell *matCellDef="let element" class="text-center"> {{element.screen_limit}} </td>
            </ng-container>

            <!-- User Limit Column -->
            <ng-container matColumnDef="members_limit">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center"> User Limit </th>
                <td mat-cell *matCellDef="let element" class="text-center"> {{element.members_limit}} </td>
            </ng-container>

            <!-- Storage Limit Column -->
            <ng-container matColumnDef="storage_limit">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center"> Storage Limit </th>
                <td mat-cell *matCellDef="let element" class="text-center"> {{element.storage_limit | bytesToReadable}}
                </td>
            </ng-container>

            <!-- Validity Period Column -->
            <ng-container matColumnDef="validity_period">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end"> Validity </th>
                <td mat-cell *matCellDef="let element" class="text-end"> {{element.validity_period | daysToDuration}}
                </td>
            </ng-container>

            <!-- Eye Icon Button Column -->
            <ng-container matColumnDef="action_button">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                    <mat-icon class="cursor-pointer" (click)="openBusinessDetail(element)">visibility</mat-icon>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>



</div>